export const otpPhoneHelper = (phone) => {
  if (phone.includes("+")) {
    return `${phone.slice(0, 3)}-${phone.slice(3)}`;
  } else if (phone.charAt(0) === "0") {
    return `+62-${phone.slice(1)}`;
  } else if (phone.charAt(0) === "6") {
    return `+${phone.slice(0, 2)}-${phone.slice(2)}`;
  } else {
    return phone;
  }
};

// Function to format the phone number
export const phoneNumberLoginOtp = (number) => {
  const cleaned = number.replace(/\D/g, "");

  // Function to dynamically create a mask based on the length of the number
  const getMaskedDigits = (length) => {
    return length > 5 ? "*".repeat(length - 5) : ""; // Mask everything except the last 5 digits
  };

  // Handle phone numbers starting with +62
  if (
    cleaned.startsWith("62") &&
    cleaned.length >= 10 &&
    cleaned.length <= 15
  ) {
    const visiblePart1 = cleaned.slice(2, 6); // First 4 digits after +62
    const visiblePart2 = cleaned.slice(6, 8); // Next 2 digits after the first 4 digits
    const maskedDigits = getMaskedDigits(cleaned.length - 8); // Mask the remaining digits after the first 6 visible digits
    return `(+62) ${visiblePart1} - ${visiblePart2}${maskedDigits}*****`;
  }

  // Handle phone numbers starting with 0
  else if (
    cleaned.startsWith("08") &&
    cleaned.length >= 9 &&
    cleaned.length <= 13
  ) {
    const visiblePart1 = cleaned.slice(1, 5); // First 4 digits after 0
    const visiblePart2 = cleaned.slice(5, 7); // Next 2 digits after the first 4 digits
    const maskedDigits = getMaskedDigits(cleaned.length - 7); // Mask the remaining digits after the first 6 visible digits
    return `(+62) ${visiblePart1} - ${visiblePart2}${maskedDigits}*****`;
  }

  return number; // If the number does not match the criteria, return as is
};

export const formatTimeCountDown = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};
